const buildLabel = (name) => {
  const label = document.createElement('label')
  label.style.padding = '0 5px'
  label.appendChild(document.createTextNode(name))
  return label
}

const stylizeInput = (input) => {
  input.style.border = 'none'
  input.style.width = '40px'
  input.style.height = '100%'
  input.style.backgroundColor = '#22313F'
  input.style.color = '#ffffff'
  input.style.fontFamily = 'Arial'
  input.style.fontSize = '10px'
  input.style.outline = 'none'
  input.style.textAlign = 'right'
  input.style.boxSizing = 'border-box'
  input.style.cursor = 'pointer'
}

const buildInput = () => {
  const input = document.createElement('input')
  stylizeInput(input)
  input.style.padding = '0 5px'
  return input
}

const buildSwitch = (onChange = ()=>{}) => {
  const input = document.createElement('div')
  const cursor = document.createElement('div')
  let value = null
  Object.defineProperty(input, 'value', {
    get : () => value,
    set : newValue => { 
      value = newValue
      cursor.style.backgroundColor = value ? '#22A7F0' : '#22313F'
      cursor.style.margin = value ? '0 auto 0 0' : '0 0 0 auto'
      onChange(value)
    }
  })
  stylizeInput(input)
  cursor.style.backgroundColor = '#22A7F0'
  cursor.style.width = '50%'
  cursor.style.height = '100%'
  cursor.style.margin = '0 0 0 auto'
  input.style.backgroundColor = '#212121'
  input.addEventListener('click', ()=>{ input.value = !input.value })
  input.appendChild(cursor)
  return input
}

const buildEntry = (label, input) => {
  const el = document.createElement('li')
  el.className = 'debugger__item'
  el.style.display = 'flex'
  el.style.justifyContent = 'space-between'
  el.style.alignItems = 'center'
  el.style.height = '20px'
  el.appendChild(label)
  if (input) el.appendChild(input)
  return el
}

class DebugUI {

  constructor () {
    this.el = this.createDebugger()
    document.body.appendChild(this.el)
    this.inputs = []
    this.props = []
    this.updateDisplay()
  }

  createDebugger () {
    const el = document.createElement('ul')
    el.className = 'debugger'
    el.style.position = 'fixed'
    el.style.backgroundColor = '#2C3E50'
    el.style.color = '#ffffff'
    el.style.fontFamily = 'Arial'
    el.style.fontSize = '10px'
    el.style.zIndex = 100
    el.style.top = 0
    el.style.left = 0
    el.style.margin = 0
    el.style.padding = 0
    return el
  }

  formatValue (value) {
    return parseFloat(value).toFixed(2)
  }

  updateDisplay () {
    this.inputs.map((input, id) => {
      const {obj, prop} = this.props[id]
      if (!input.focus) input.value = this.formatValue(obj[prop])
      return input.value
    })
    requestAnimationFrame(()=>this.updateDisplay())
  }

  onKeyUp (e, onChange) {
    if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return 
    const inccValue = 1.0 * (e.shiftKey ? 10 :  1) * (e.altKey ? 0.1 : 1)
    let newValue = parseFloat(e.target.value);
    if (e.key === 'ArrowUp') {
      newValue += inccValue
    }
    if (e.key === 'ArrowDown') {
      newValue -= inccValue
    }
    e.target.value = this.formatValue(newValue)
    onChange(newValue)
  }

  addBoolean (obj, prop, name, onChange) {
    const input = buildSwitch(onChange)
    const label = buildLabel(name)
    const el = buildEntry(label, input)
    input.value = obj[prop]
    this.el.appendChild(el)
  }

  addInput (obj, prop, name, onChange) {
    const input = buildInput()
    const label = buildLabel(name)
    const el = buildEntry(label, input)
    input.focus = false
    input.value = this.formatValue(obj[prop])
    input.addEventListener('change', () => onChange(input.value))
    input.addEventListener('keyup', e => this.onKeyUp(e, onChange))
    input.addEventListener('focus', e => input.focus = true)
    input.addEventListener('blur', e => input.focus = false)
    this.inputs.push(input)
    this.props.push({ obj, prop })
    this.el.appendChild(el)
  }

  addFolder (name) {
    const label = buildLabel(name)
    const el = buildEntry(label)
    el.style.backgroundColor = '#22313F'
    this.el.appendChild(el)
  }

  debugMotionCamera (camera, onChange=()=>{}, folderName = null) {
    const updateCam = (prop = {}, attr = 0, value = 0) => {
      prop[attr] = parseFloat(value)
      camera.lookAt(camera.target)
      onChange()
    }
    if (folderName) this.addFolder(folderName)
    this.addInput(camera.position, 'x', 'cam X', value => updateCam(camera.position, 'x', value), camera.position.x)
    this.addInput(camera.position, 'y', 'cam Y', value => updateCam(camera.position, 'y', value), camera.position.y)
    this.addInput(camera.position, 'z', 'cam Z', value => updateCam(camera.position, 'z', value), camera.position.z)
    this.addInput(camera.target, 'x', 'target X', value => updateCam(camera.target, 'x', value), camera.target.x)
    this.addInput(camera.target, 'y', 'target Y', value => updateCam(camera.target, 'y', value), camera.target.y)
    this.addInput(camera.target, 'z', 'target Z', value => updateCam(camera.target, 'z', value), camera.target.z)
    updateCam()
  }

}
export default DebugUI


// WEBPACK FOOTER //
// ./src/scripts/DebugUI.js